import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {KeyboardAvoidingView, View, Platform} from 'react-native';
import {TopTab, TopTabButton} from 'src/Modules/TabViews';

import HomeActivityLists from 'src/LandingPage/Home/HomeActivityLists';

import HuntSearchView from 'src/LandingPage/Home/HuntSearchView';

import HomeLandingMap from './HomeLandingMap';
import StickyFooterButton from '../../Modules/CommonView/StickyFooterButton';
import CallSupportLine from '../../HeaderComponents/CallSupportLine';
import {
  updateHomeState,
  updateHomeView,
} from '../../Redux/reducers/home.reducer';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {setCurrentGroupId} from 'src/Redux/reducers/user_info.reducer';
import {clearGroupInfo} from '../../Redux/reducers/groupInfo.reducer';

import {setPreviousVisit} from '../../Redux/reducers/current_screen.reducer';
import {mmkvStorage} from '../../Utils/mmkvStorage';
//

const HomeLandingTab = () => {
  const dispatch = useDispatch();

  const userPassportId = useSelector(
    (state) => state.user?.info?.activePassportId,
  );

  const checkPreviousVisit = async () => {
    let previousVisit = !!(await mmkvStorage.getString('previousVisit'))
      ? true
      : false;
    if (!previousVisit) {
      setTimeout(() => {
        mmkvStorage.set('previousVisit', 'true');
        dispatch(setPreviousVisit(1));
      }, 500);
    }
  };
  const playTestState = useSelector((state) => state.app_info?.playTestState);
  const delayedDeepLink = useSelector(
    (state) => state.current_screen?.delayedDeepLink,
  );
  const isOnLoadingScreens = useSelector((state) =>
    ['AppIntroSwiper', 'LoginPage']?.includes(
      state.current_screen?.currentScreen,
    ),
  );

  const [copilotPressed, setCopilotPressed] = useState(0);

  // checking for copilot
  // here because updates were affecting
  useEffect(() => {
    const hasViewedTutorial = mmkvStorage.getString('hasViewedTutorial');

    if (playTestState) {
      return;
    }

    if (delayedDeepLink) {
      return console.log('will open deep link first');
    }

    if (isOnLoadingScreens) {
      return console.log('copiolot: not on loading page');
    }

    if (hasViewedTutorial) {
      return console.log('already has seen copoliot');
    }
    setTimeout(() => {
      if (!copilotPressed) {
        setCopilotPressed(1);
        // start?.();
      }
    }, 1000);
  }, [isOnLoadingScreens, delayedDeepLink]);

  useEffect(() => {
    checkPreviousVisit();
  }, []);

  const homeActiveSearch = useSelector((state) => state.home?.homeActiveSearch);
  const homeView = useSelector((state) => state.home?.homeView);

  useEffect(() => {
    dispatch(setCurrentGroupId(null));
    dispatch(clearGroupInfo());
  }, []);

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      keyboardVerticalOffset={75}
      enabled
      style={{flex: 1, position: 'relative', backgroundColor: 'white'}}>
      <CallSupportLine />
      <TopTab>
        <TopTabButton
          text={'Activities List'}
          index={0}
          active={homeView === 'list'}
          handlePress={() =>
            dispatch(
              updateHomeState({
                homeSearchText: null,
                homeActiveSearch: 0,
                homeView: 'list',
              }),
            )
          }
        />
        <TopTabButton
          text={'Activities Map'}
          index={1}
          active={homeView === 'map'}
          handlePress={() => dispatch(updateHomeView('map'))}
        />
      </TopTab>
      <View
        style={{
          flex: 1,
          position: 'relative',
          backgroundColor: global?.color?.white1,
        }}>
        {homeView === 'map' && <HomeLandingMap />}

        <HuntSearchView />

        {homeView === 'list' && !homeActiveSearch && <HomeActivityLists />}

        {!userPassportId &&
          homeView != 'map' &&
          !homeActiveSearch &&
          playTestState == false && (
            <StickyFooterButton
              text={'Become Member'}
              color={global?.color?.blue}
              handlePress={() =>
                navigationRef.navigate('PurchaseModal', {
                  showMembershipOnly: true,
                })
              }
            />
          )}
      </View>
    </KeyboardAvoidingView>
  );
};

export default HomeLandingTab;
